/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

const useDidMount = effect => {
	useEffect(effect, []);
};

export { useDidMount };
